const MODIFIERS_DEFAULT = ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip']
const MODIFIERS_NO_ARROW = ['shift', 'offset', 'preventOverflow', 'keepTogether', 'flip']

function popperSmartPositionMod(data) {
    if (data.offsets.reference.width < data.offsets.popper.width) {
        data.instance._popper.style.left = 120 - data.offsets.reference.width / 2 + 'px'
        data.arrowElement.style.left = data.offsets.reference.width / 2 + 'px'
    }
    return data
}

function popperArrowSpaceMod(offset) {
    return data => {
        const { popper, reference } = data.offsets

        if (data.placement.indexOf('left') !== -1) {
            popper.left = reference.left - offset - popper.width
        } else if (data.placement.indexOf('right') !== -1) {
            popper.left = reference.right + offset
        } else if (data.placement.indexOf('top') !== -1) {
            popper.top = reference.top - offset - popper.height
        } else if (data.placement.indexOf('bottom') !== -1) {
            popper.top = reference.bottom + offset
        }

        return data
    }
}

const createVirtualPopperReferenceElement = (x, y) => {
    const baseElement = document.createElement('div')
    baseElement.getBoundingClientRect = () => {
        return {
            bottom: y,
            height: 0,
            left: x,
            right: x,
            top: y,
            width: 0,
            x,
            y
        }
    }
    return baseElement
}

/**
 * function that returns a default virtual element used by popper to position the popover if no attach element
 * is available. it is centered in the screen with a slight (100px) offset towards the lower edge of the screen
 */
const createDefaultVirtualPopperReferenceElement = () =>
    createVirtualPopperReferenceElement(
        document.documentElement.clientWidth / 2,
        document.documentElement.clientHeight / 2 + 50
    )

export {
    MODIFIERS_DEFAULT,
    MODIFIERS_NO_ARROW,
    popperSmartPositionMod,
    createVirtualPopperReferenceElement,
    createDefaultVirtualPopperReferenceElement,
    popperArrowSpaceMod
}
